class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        this.getDeliveryDate(); // Appeler après avoir mis à jour le DOM
      })
      .catch(e => {
        console.error(e);
      });
  }
  getDeliveryDate() {
    const today = new Date();
    var currentTime = today.getHours();
    var fromDate = new Date();
    fromDate.setDate(today.getDate() + 2); // Utilisation de setDate pour ajouter des jours    
    if (today.is().monday()) {
        fromDate = fromDate.next().thursday();
      }
      if (today.is().tuesday()) {
        fromDate = fromDate.next().friday();
      }

      if (today.is().wednesday()) {
        fromDate = fromDate.next().saturday();
      }
      if (today.is().thursday()) {
        fromDate = fromDate.next().tuesday();
      }

      if (today.is().friday()) {
        fromDate = fromDate.next().wednesday();
      }

      if (today.is().saturday()) {
        fromDate = fromDate.next().wednesday();
      }

      if (today.is().sunday()) {
        fromDate = fromDate.next().wednesday();
      }

    let options = { weekday: 'long', month: 'long', day: 'numeric' };
    const text = document.getElementById("fromDate");
    if (text) {
      text.innerHTML = fromDate.toLocaleString('fr-FR', options);
    } else {
      console.error('Element with id "fromDate" not found inside mini-cart.');
    }
  }
}
customElements.define('cart-recommendations', CartRecommendations);
